import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// Activate/deactivate the languages here
// , 
const languages = ['en', 'de', 'it', 'fr'];
let fallbackLocale = "de";

// Used for the debug
const isProd = process.env.NODE_ENV === "production";

// Loads up all files at boot
function loadLocaleMessages () {
  const files = require.context('./lang', true, /translations\.json$/i);
  if (files.length === 0) {
    console.error("No translation files found!")
    return {};
  } else if (files.length > 1) {
    // Load the first one
    console.log("Loading the first file!");
  }

  let base = files(files.keys()[0]);
  let translations = {};
  for (var i = 0; i < languages.length; i++) {
    let lang = languages[i];
    translations[lang] = transform(base, {}, lang, "$");
  }

  return translations
}

function isTranslationObj(obj) {
	return arraysEqual(Object.keys(obj), languages);
}

function arraysEqual(a, b) {
	let aSet = new Set(a);
	let bSet = new Set(b);



	if (aSet === bSet) return true;
	if (aSet == null || bSet == null) return false;
	if (aSet.length != bSet.length) return false;

	// Iterate over the first set, and check we have the same keys
	let aKeys = Array.from(aSet);

	for (var i = 0; i < aKeys.length; i++) {
		if (!bSet.has(aKeys[i])) {
			return false;
		}
	}

	return true;
}



function transform(translated, transformed, locale, path) {
	// translated is the formatted file
	// transormed is what we have up to now
	//	console.log("Translated: " + JSON.stringify(translated))
	//	console.log("Transformed: " + JSON.stringify(transformed))
	//	console.log("==========")

	if (isTranslationObj(translated)) {
		let translatedWord = translated[locale];

		if (translatedWord === undefined || translatedWord === null || translatedWord === '') {
			if (!isProd) {
				console.error(`Missing translation for locale '${locale}' @ '${path}'`);
			}
			return translated[fallbackLocale];
		}

		return translatedWord;

	} else {
		Object.keys(translated).forEach(key => {
			let currentObj = translated[key];
			let currentKeys = Object.keys(currentObj);
			// Check the type
			if (currentObj instanceof Array) {
				// Prepare the array
				transformed[key] = []
				// Iterate over each entry, and process it separately
				for (var i = 0; i < currentObj.length; i++) {
					transformed[key][i] = {};
					transformed[key][i] = transform(currentObj[i], transformed[key][i], locale, `${path}.${key}.[${i}]`);
				}
				return transformed;
			} else if (currentObj instanceof Object) {
				transformed[key] = transform(currentObj, {}, locale, `${path}.${key}`);
				return transformed;
			} else  if (typeof currentObj === "string"){
				transformed[key] = currentObj;
				return transformed;
			}
		});
	}
	return transformed;
}


  export const i18n = new VueI18n({
    locale: fallbackLocale,
    fallbackLocale: fallbackLocale,
    messages: loadLocaleMessages()
  })